import { useKeycloak } from "@react-keycloak/web";
import React, { useEffect, useState } from "react";
import { useFetchBOSocieteAllMarquesQuery } from "../../../redux/slice/api/BO/societeApi";
import { IMarque } from "../../../models/interfaces/IMarques";
import CpntDataTable from "../../../components/dataTable/CpntDataTable";
import { ILocation } from "../../../models/interfaces/ILocation";
import { ITitle } from "../../../models/interfaces/ITitle";
import SpinnerEditeurPro from "../../FO/components/SpinnerEditeurPro";


interface IProps {
  IdSociete: number;
  refetch: boolean;
}


const BOCompteSocieteTabFond: React.FC<IProps> = ({ IdSociete,refetch }) => {

  const { initialized: keycloakinitialized,keycloak } = useKeycloak();
 const [fetchFond, setFetchFond] = useState(refetch);
 
  //Marques 
  const { data: SocieteMarquesResult, isFetching: SocieteMarquesisFetching, error: SocieteMarqueserror } = useFetchBOSocieteAllMarquesQuery(IdSociete, {
    refetchOnMountOrArgChange: true,
    skip: !keycloakinitialized || !keycloak.authenticated || IdSociete === 0 || fetchFond ===false,
  });
    useEffect(() => {
      setFetchFond(refetch);
    }, [refetch])

  
  const actions: ILocation[] = [
    // {
    //   PathsName: { CompteSociete: "/admin/comptesociete/[[IdSociete]]"},
    //   State: { type_access: "" },
    //   ClassName: "bi-receipt Action-button",
    // },
  ];

  const dataHeaderName: ITitle[] = [
    // {
    //   Id: "Id",
    //   Name: "Id",
    //   Class: "",
    //   sorter: (a: IMarque, b: IMarque) =>
    //     a.Id - b?.Id,
    // },
    {
      Id: "IdExterne",
      Name: "Id Marque",
      Class: "",
      sorter: (a: IMarque, b: IMarque) =>
        a.IdExterne - b?.IdExterne,
    },
    {
      Id: "Libelle",
      Name: "Libelle",
      Class: "",
      sorter: (a: IMarque, b: IMarque) =>
        a?.Libelle?.localeCompare(b?.Libelle),
    },
    {
      Id: "Source",
      Name: "Source",
      Class: "",
      sorter: (a: IMarque, b: IMarque) =>
        a?.Source?.localeCompare(b?.Source),
    },
  ];


  const dataItemsStyle = {
    // Id: "",
    IdExterne:"",
    Libelle: "",
    Source: ""
  };

 
 
  return (
    <>
     {SocieteMarquesisFetching ? (
      <SpinnerEditeurPro />
          ) : SocieteMarqueserror ? (
            <div>Error</div>
          ) : (
            SocieteMarquesResult?.Marques && //&& numberOfResults !== null && numberOfResults > 0 &&
              <>
              {/* <CpntPagination limit={limit} offset={offset} numberOfResults={numberOfResults} setLimit={(Limit) => setLimit(Limit)} setOffset={(offset) => setOffset(offset)}></CpntPagination> */}
              <div style={{display: 'flex', justifyContent: 'flex-end'}}>
              <div className="col-1.5" style={{margin:"5px"}}>
                Nombre total de marque(s): <b>{SocieteMarquesResult?.Marques?.length}</b>
              </div> 
              </div>
              <div className="card p-0 mb-2">
                <div className="table-responsive">
                  <CpntDataTable
                    data={SocieteMarquesResult && SocieteMarquesResult?.Marques ? [...SocieteMarquesResult.Marques] : []}
                    dataHeader={dataHeaderName}
                    dataItemsStyle={dataItemsStyle}
                    actions={actions}
                    actualFilterPage="PagBOComptesSociete"
                    // updateSorter={setSortField}
                    // updateDescending={setIsDescending}
                />
                </div>
              </div>
              {/* <CpntPagination limit={limit} offset={offset} numberOfResults={numberOfResults} setLimit={(Limit) => setLimit(Limit)} setOffset={(offset) => setOffset(offset)}></CpntPagination> */}

              </>
          )}
      </>
  )
    
}; 

export default BOCompteSocieteTabFond;

